<template lang="html">

 <div class="wrapper-redes flex wrap justify-between" :show="show" :data="selected">

        <div class="wrapper-follow">
          <div class="">
            <p class="texto">{{$t('footer.en_redes')}}</p>
            <p class="texto">{{$t('footer.twitter')}}</p>
            <p class="texto">{{$t('footer.facebook')}}</p>
            <p class="texto">{{$t('footer.instagram')}}</p>
            <p class="texto">{{$t('footer.canal')}}</p>
          </div>
        </div>

        <ul class="f-redes flex row justify-start contenedor-redes-sociales">

          <li data="twitter" @mouseover="set('twitter')">
            <a class="fa-brands fa-x-twitter" href="https://twitter.com/ajusa_spain?" target="_blank"></a>
          </li>
          <li data="facebook" @mouseover="set('facebook')">
            <a class="fa fa-facebook" href="https://www.facebook.com/AjusaSpain/" target="_blank"></a>
          </li>
          <li data="instagram" @mouseover="set('instagram')">
            <a class="fa fa-instagram" href="https://www.instagram.com/ajusa_automotive/" target="_blank"></a>
          </li>
          <li data="youtube" @mouseover="set('youtube')">
            <a class="fa fa-youtube" href="https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg" target="_blank"></a>
          </li>
          <li data="linkedin" @mouseover="set('linkedin')">
            <a class="fa fa-linkedin" href="https://www.linkedin.com/company/ajusa" target="_blank"></a>
          </li>
          
        </ul>
        <a class="cerrar" @click="toggle">✕</a>
      </div>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'rrss-slide',
    props: ['show'],
    methods: {
        toggle : function(){
          this.$emit('toggle');
        },
        set : function (value){
          this.selected = value;
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/view-parts/footer-parts/rrss-slide.vue